import { markets } from '$lib/home/store';
import type { MarketIdentifiers } from '$lib/types/market';
import { derived, get, type Readable } from 'svelte/store';

export const getMarketCurrentMarketPrice = (market: string) => {
	const marketData = get(markets).find((m) => m.marketIdentifier === market);
	if (marketData) {
		return marketData.currentMarketPrice;
	}
	return '0';
};

type marketPrice = { [key in MarketIdentifiers]: string };

export const marketPrices = derived(markets, ($markets) => {
	let data: marketPrice = {};
	$markets.forEach((m) => {
		data[m.marketIdentifier] = m.currentMarketPrice;
	});
	return data;
});
